import React from "react";
import { cn } from "@/lib/utils";

interface TwoColumnLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  reverse?: boolean;
  leftWidth?: "1/3" | "1/2" | "2/3";
  gap?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({
  leftContent,
  rightContent,
  reverse = false,
  leftWidth = "1/2",
  gap = "lg",
  className,
}) => {
  const gapClasses = {
    sm: "gap-4",
    md: "gap-6",
    lg: "gap-8",
    xl: "gap-12",
  };

  const widthClasses = {
    "1/3": "lg:w-1/3",
    "1/2": "lg:flex-1",
    "2/3": "lg:w-2/3",
  };

  return (
    <div
      className={cn(
        "flex w-full flex-col gap-6 lg:flex-row lg:items-start",
        gapClasses[gap],
        reverse && "lg:flex-row-reverse",
        className
      )}
    >
      <div className={cn("flex flex-col", widthClasses[leftWidth])}>
        {leftContent}
      </div>
      <div className="flex flex-1 flex-col">{rightContent}</div>
    </div>
  );
};

export default TwoColumnLayout;
